import React, { useEffect } from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { corporateColor, greyBg, NECROPSY_STATE, white } from '../../../../../../theme/colors'
import { Button } from '../../../../../../components/Button'
import { useForm } from '../../../../../../hooks/useForm'
import { StateForm } from '../../../../../../context/Logistics/fuel/types'

interface Props {
  onChange: (state: StateForm | null) => void
}

interface Values {
  selectedOption: StateForm | null
}

export const Filters = ({ onChange }: Props) => {
  const { values, onChangeValues } = useForm<Values>({ selectedOption: null })

  const toggle = (state: StateForm) => {
    onChangeValues({
      name: 'selectedOption',
      value: values.selectedOption === state ? null : state,
    })
  }

  useEffect(() => {
    onChange(values.selectedOption)
  }, [values])

  return (
    <View style={style.container}>
      <Text style={style.title}>Filtros</Text>
      <View style={{ flexWrap: 'wrap', flexDirection: 'row', paddingVertical: 16, gap: 8 }}>
        <Button
          label='Enviado'
          onPress={() => toggle('sent')}
          customStyle={[
            style.btn,
            values.selectedOption === 'sent' && { backgroundColor: NECROPSY_STATE.sent },
          ]}
          labelStyle={[style.labelBtn, values.selectedOption === 'sent' && { color: white }]}
          closeIcon={values.selectedOption === 'sent'}
        />
        <Button
          label='Sincronizando'
          onPress={() => toggle('sending')}
          customStyle={[
            style.btn,
            values.selectedOption === 'sending' && { backgroundColor: NECROPSY_STATE.sending },
          ]}
          labelStyle={[style.labelBtn, values.selectedOption === 'sending' && { color: white }]}
          closeIcon={values.selectedOption === 'sending'}
        />
        <Button
          label='No enviado'
          onPress={() => toggle('pending')}
          customStyle={[
            style.btn,
            values.selectedOption === 'pending' && { backgroundColor: NECROPSY_STATE.pending },
          ]}
          labelStyle={[style.labelBtn, values.selectedOption === 'pending' && { color: white }]}
          closeIcon={values.selectedOption === 'pending'}
        />
        <Button
          label='En progreso'
          onPress={() => toggle('in-progress')}
          customStyle={[
            style.btn,
            values.selectedOption === 'in-progress' && { backgroundColor: '#F5A623' },
          ]}
          labelStyle={[style.labelBtn, values.selectedOption === 'in-progress' && { color: white }]}
          closeIcon={values.selectedOption === 'in-progress'}
        />
      </View>
    </View>
  )
}

const style = StyleSheet.create({
  container: { backgroundColor: greyBg, paddingTop: 24, paddingHorizontal: 24 },
  title: { color: corporateColor, fontSize: 16, fontWeight: '400' },
  btn: {
    backgroundColor: white,
    marginLeft: 0,
    marginRight: 0,
    marginTop: 0,
    padding: 10,
    width: 'auto',
  },
  labelBtn: { color: corporateColor, fontSize: 15, fontWeight: '600' },
})
